// extracted by mini-css-extract-plugin
module.exports = {"searchTag":"SearchTag_searchTag__3Oenr","removable":"SearchTag_removable__T9-zy","closeBtn":"SearchTag_closeBtn__3HIoM"};